module.exports = __webpack_public_path__ + "img/img06.ad8fd966.png";